<ws-modal-wrapper headerLabel="Assessors"
                  [suppressKeyboardEvents]="true"
                  (save)="save()"
                  (cancel)="cancel()"
                  [loading]="loading"
                  [disableSave]="!hasChanges || loading">
    <div class="ws-flex-container-horizontal ws-flex-align-items-center">
        <ag-grid-row-count [gridApi]="gridApi"
                           [gridTracker]="gridTracker"
                           [gridOptions]="gridOptions"></ag-grid-row-count>
    </div>
    <ws-ag-grid-angular [gridOptions]="gridOptions"
                        (gridReady)="onAgGridReady($event)">
    </ws-ag-grid-angular>
</ws-modal-wrapper>
